import { Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useQueries } from '@tanstack/react-query'
import DinamicTable from 'components/dinamic-table'
import InError from 'components/error'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { IProjectDTO, ISnowFlakeTableDTO } from 'data/dtos/automation/i-project-dto'
import { useState } from 'react'
import { load, loadItem } from 'services/requests'
import { captalize } from 'utils/captalize'
import AdesaoCustomTable from '../adesao-custom-table/ index'

interface ITableData {
  data: any[]
  count: number
}

interface TablePreviewProps {
  snowflakeTableId: string
  organizationId: string
  projectId: string
  project: IProjectDTO
}

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },
}))

const TablePreview = ({ organizationId, project, projectId, snowflakeTableId }: TablePreviewProps) => {
  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)
  const { VITE_APP_AMBIENT } = import.meta.env

  const classes = useStyles()

  const handleChangePage = (value: number) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const [content, snowflake] = useQueries({
    queries: [
      {
        queryKey: ['table', snowflakeTableId, page, rowsPerPage],
        queryFn: () =>
          load('/conducco-cdp-organizations/select-all-data', {
            snowflakeTableId: snowflakeTableId,
            organizationIdOutput: project.organizationOutput.id,
            database: 'dbconducco',
            page: page,
            rowsPerPage: rowsPerPage,
            contractId: project.contractId,
          }),
        enabled: snowflakeTableId != null && project != null,
      },
      {
        queryKey: ['snowflake-tables', snowflakeTableId],
        queryFn: () => loadItem('/snowflake-tables', snowflakeTableId),
        enabled: snowflakeTableId != null,
      },
    ],
  })

  if (content.isLoading || snowflake.isPending) {
    return (
      <WrapperWithHeader>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </WrapperWithHeader>
    )
  }

  if (content.isLoading || snowflake.isPending) {
    return (
      <WrapperWithHeader>
        <InError message='Error ao Carregar a Tabela' />
      </WrapperWithHeader>
    )
  }

  let tableData = {
    data: [],
    count: 0,
  } as ITableData

  if (content?.data) {
    tableData = (content?.data as any).data.data as ITableData
  }

  const snowFlakeTableData = (snowflake?.data as any).data.data as ISnowFlakeTableDTO
  const organizationName = project.organizationOutput?.corporateName
  const backRoute = `/projects/${projectId}/${organizationId}`

  if (snowFlakeTableData.name == 'campanha_de_adesao' && VITE_APP_AMBIENT !== 'prod') {
    return (
      <AdesaoCustomTable
        tableLabel={`Tabela: ${captalize(snowFlakeTableData.label)}`}
        backRoute={backRoute}
        organizationName={organizationName}
        projectIsInactive={project.isInactive}
      />
    )
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text={`Tabela: ${captalize(snowFlakeTableData.label)}`}
          backRoute={backRoute}
        />
      </Header>

      <Page>
        <Box className={classes.root}>
          <DinamicTable
            data={tableData.data}
            rowsPerPage={rowsPerPage}
            page={page}
            isLoading={snowflake.isPending || content.isLoading}
            totalPages={Math.ceil(tableData.count || 0 / rowsPerPage)}
            handleNextPage={() => setPage(page + 1)}
            handlePrevPage={() => setPage(page - 1)}
            onChangeRowPerPage={handleChangePage}
          />
        </Box>
      </Page>
    </Wrapper>
  )
}

export default TablePreview
